<template>
  <div class="currencySetting">
    <el-form
      ref="addForm"
      :model="addForm"
      :label-width="formLabelWidth"
      :rules="addFormRules"
    >
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="微信公众号二维码" prop="logo">
            <div>
              <el-upload
                action
                ref="upload"
                :http-request="fnUploadRequest"
                class="avatar-uploader-logo"
                :show-file-list="false"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img
                  class="currencySetting-image"
                  style="margin-left: 20px"
                  v-if="addForm.wechatPublicAccountQrcode"
                  :src="addForm.wechatPublicAccountQrcode"
                  height="150"
                  width="150"
                />
              </el-upload>
            </div>
            <div class="paySetting-tips">
              图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为150*150.
            </div>
          </el-form-item>
        </el-col>
      </el-row>
       <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="微信客服二维码" prop="logo">
            <div>
              <el-upload
                action
                ref="upload"
                :http-request="customServiceUploadRequest"
                class="avatar-uploader-logo"
                :show-file-list="false"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <img
                  class="currencySetting-image"
                  style="margin-left: 20px"
                  v-if="addForm.customerServiceAccountQrcode"
                  :src="addForm.customerServiceAccountQrcode"
                  height="150"
                  width="150"
                />
              </el-upload>
            </div>
            <div class="paySetting-tips">
              图片大小不超过1M，仅支持jpg，png格式，最佳尺寸为150*150.
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="微信公众号名称" prop="wechatPublicAccountName">
            <el-input
              v-model="addForm.wechatPublicAccountName"
              placeholder="微信公众号名称"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
         <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="客服联系邮箱" prop="email">
            <el-input
              v-model="addForm.email"
              placeholder="客服联系邮箱"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
       <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="客服工作时间" prop="serviceTime">
            <el-input
              v-model="addForm.serviceTime"
              placeholder="周一至周五09:00-18:00"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="16" :lg="16">
          <el-form-item label="客服联系电话" prop="tel2">
            <el-input
              style="width: 150px"
              v-model="addForm.tel2[0]"
              placeholder="联系电话1"
              auto-complete="off"
            ></el-input>
            <el-input
              style="width: 150px"
              v-model="addForm.tel2[1]"
              placeholder="联系电话2"
              auto-complete="off"
            ></el-input>
            <el-input
              style="width: 150px"
              v-model="addForm.tel2[2]"
              placeholder="联系电话3"
              auto-complete="off"
            ></el-input>
            <el-input
              style="width: 150px"
              v-model="addForm.tel2[3]"
              placeholder="联系电话4"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="客服类型" prop="type">
            <el-radio-group v-model="addForm.type" @change="radioChange()">
              <el-radio :label="1">个人QQ</el-radio>
              <el-radio :label="2">企业QQ</el-radio>
              <el-radio :label="3">百度商桥</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" :lg="16">
          <el-form-item label="账号或密钥" prop="account2">
            <template v-if="addForm.type == 1">
              <el-input
                style="width: 150px"
                v-model="addForm.account2[0]"
                placeholder="个人QQ1"
                auto-complete="off"
              ></el-input>
              <el-input
                style="width: 150px"
                v-model="addForm.account2[1]"
                placeholder="个人QQ2"
                auto-complete="off"
              ></el-input>
              <el-input
                style="width: 150px"
                v-model="addForm.account2[2]"
                placeholder="个人QQ3"
                auto-complete="off"
              ></el-input>
              <el-input
                style="width: 150px"
                v-model="addForm.account2[3]"
                placeholder="个人QQ4"
                auto-complete="off"
              ></el-input>
              <div>
                <el-input
                  style="width: 150px"
                  v-model="addForm.account2[4]"
                  placeholder="个人QQ5"
                  auto-complete="off"
                ></el-input>
                <el-input
                  style="width: 150px"
                  v-model="addForm.account2[5]"
                  placeholder="个人QQ6"
                  auto-complete="off"
                ></el-input>
                <el-input
                  style="width: 150px"
                  v-model="addForm.account2[6]"
                  placeholder="个人QQ7"
                  auto-complete="off"
                ></el-input>
              </div>
              <div class="paySetting-tips">
                根据所选客服类型填写对应的号码或密钥，若选择个人QQ且有多个QQ号码(最多支持7个)请分别填入对应的输入框内，
                输入其它格式或中文电话客服功能将无效，小程序不支持乐语、百度商桥客服功能，QQ、企业QQ仅能展示号和复制功能
              </div>
            </template>
            <template v-else>
              <el-input
                v-model="addForm.account2"
                placeholder="账号或密钥"
                auto-complete="off"
              ></el-input>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="24" :lg="16">
          <el-form-item label="移动端悬浮显示" prop="displayFloat">
            <el-switch
              v-model="addForm.displayFloat"
              :active-value="1"
              :inactive-value="-1"
              active-text="开"
              inactive-text="关"
              class="switchStyle2"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <!-- <el-button>重置</el-button> -->
      <el-button
        style="margin-left: 120px"
        type="primary"
        @click="submit()"
        :loading="submitLoading"
        >保存</el-button
      >
    </div>
  </div>
</template>
<script>
import { uploadOSS } from "../../upload/upload";
export default {
  data() {
    var validateMobile = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if (typeof value == "object") {
          var reg = /^1[3456789]\d{9}$/;
          var reg2 = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
          var re = /(\x0f[^\x0f]+)\x0f[\s\S]*\1/.test(
            "\x0f" + value.join("\x0f\x0f") + "\x0f"
          );
          if (re) {
            callback(new Error("联系号码存在重复号码"));
          }
          value.forEach((e) => {
            if (!reg.test(e) && !reg2.test(e)) {
              callback(new Error("请输入正确的联系号码"));
            }
          });
        }
        callback();
      }
    };
    let that = this;
    return {
      editBlock: false,
      submitLoading: false,
      addForm: {
        wechatPublicAccountQrcode: null,
        wechatPublicAccountName: null,
        tel: [],
        tel2: [],
        account: [],
        account2: [],
        type: 1,
        displayFloat: 1,
      },
      formLabelWidth: "120px",
      addFormRules: {
        tel2: {
          validator: validateMobile,
          trigger: "blur",
        },
      },
      imgUrl: null,
    };
  },
  created() {
  },
  methods: {
    fnUploadRequest(file) {
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "Setting").then((result) => {
          this.$set(this.addForm, "wechatPublicAccountQrcode", result);
        });
      }
    },
    customServiceUploadRequest(file) {
      const isJPG = file.file.type === "image/jpeg" || file.file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/png 格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 1) {
        this.$message.error("图片大小不能超过1M");
      } else {
        uploadOSS(file, "Setting").then((result) => {
          this.$set(this.addForm, "customerServiceAccountQrcode", result);
        });
      }
    },
    getCustomerServiceSetting() {
      this.api.customerServiceSetting.getCustomerServiceSetting().then((result) => {
        if (result.success) {
          if (result.data != null) {
            this.addForm = result.data;
            this.$set(this.addForm, "tel2", []);
            this.$set(this.addForm, "account2", []);
            result.data.tel.split(",").forEach((e) => {
              if (e != "") {
                this.addForm.tel2.push(e);
              }
            });
            result.data.account.split(",").forEach((e) => {
              if (e != "") {
                this.addForm.account2.push(e);
              }
            });
            this.editBlock = true;
          } else {
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    radioChange() {
      if (this.addForm.type == 1) {
        this.addForm.account2 = [];
      } else {
        this.addForm.account2 = "";
      }
      console.log("this", this.addForm.type);
    },
    submit() {
      if (this.submitLoading) {
        return;
      }
      this.addForm.tel2.forEach((e, index) => {
        if (e == "") {
          this.addForm.tel2.splice(index, 1);
        }
      });
      this.addForm.account2.forEach((e, index) => {
        if (e == "") {
          this.addForm.account2.splice(index, 1);
        }
      });

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.editBlock) {
            this.updateCustomerServiceSetting();
          } else {
            this.addCustomerServiceSetting();
          }
        }
      });
    },
    addCustomerServiceSetting() {
      this.addForm.tel = this.addForm.tel2.join(",");
      this.addForm.account = this.addForm.account2.join(",");
      this.api.customerServiceSetting
        .addCustomerServiceSetting(this.addForm)
        .then((result) => {
          if (result.success) {
            this.submitLoading = false;
            this.editBlock = true;
            this.getCustomerServiceSetting();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        });
    },
    updateCustomerServiceSetting() {
      this.addForm.tel = this.addForm.tel2.join(",");
      this.addForm.account = this.addForm.account2.join(",");
      this.api.customerServiceSetting
        .updateCustomerServiceSetting(this.addForm)
        .then((result) => {
          if (result.success) {
            this.submitLoading = false;
            this.getCustomerServiceSetting();
            this.$message.success(result.message);
          } else {
            this.$message.error(result.message);
          }
        });
    },
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.getCustomerServiceSetting();
  },
};
</script>
<style scoped>
/* .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
*/
.avatar-uploader-logo{
  margin-top: 60px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.paySetting-tips {
  word-wrap: break-word;
  white-space: normal;
}
.currencySetting-image {
  border-radius: 4px;
  vertical-align: bottom;
}
</style>
<style lang="less">
.el-upload {
  // display: inline-flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setting/customerService.vue